<template>
  <div>
    <modal
      title="Add Charges"
      name="chargesAdd"
      class="custom-modal"
      height="auto"
      width="600"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-3">
          <form class="create-service mb-base">
            <Select
              label="Doctors"
              :options="filterDoctors"
              styles="mb-base"
              :input="handleDoctors"
              :clearable="false"
            />
            <Select
              label="Service Head"
              :options="servicesList"
              styles="mb-base"
              :input="handleServices"
              :clearable="false"
            />
            <Input
              class="mb-base"
              label="Amount"
              type="text"
              v-model="charges.amount"
            />
            <Select
              v-if="isAdmin"
              styles="mb-base py-2"
              placeholder="Filter by Branch"
              :input="handleBranchChange"
              :options="brachData"
            />
            <Button
              className="button--primary"
              title="Save"
              :loader="loading"
              :onClick="handleCharges"
            ></Button>
          </form>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import Button from "@/components/Button";
import Select from "@/components/Select";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Select,
    Modal,
    Input,
    Button
  },
  data() {
    return {
      charges: {},
      brachData: [],
      isAdmin: false
    };
  },
  methods: {
    ...mapActions("expenses", ["fetchBranch"]),
    ...mapActions({
      filterEmployees: "user/filterEmployees",
      doctorList: "doctors/doctorList",
      addCharges: "services/addCharges"
    }),
    handleCharges() {
      this.addCharges(this.charges).then(() => {
        this.$modal.hide("chargesAdd");
        this.charges = {};
      });
    },
    handleDoctors(val) {
      this.charges.userId = val.id;
    },
    handleServices(val) {
      this.charges.lookupId = val.id;
    },
    handleBranchChange(val) {
      this.charges.branchId = val.key;
    }
  },
  computed: {
    ...mapGetters({
      listEmployees: "user/listEmployees",
      listDoctors: "doctors/listDoctors",
      user: "auth/userInfo",
      loading: "loading",
      fetchUserBranch: "expenses/fetchUserBranch"
    }),
    filterDoctors() {
      return (
        this.listEmployees &&
        this.listEmployees.map(item => ({
          id: item.userId,
          name: item.full_name
        }))
      );
    },
    servicesList() {
      return (
        this.listDoctors &&
        this.listDoctors.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    }
  },
  async mounted() {
    this.doctorList("servicehead");
    this.filterEmployees("doctor");
    await this.fetchBranch();
    await this.fetchUserBranch.map(elem => {
      this.value = elem.name;
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    this.isAdmin = this.user?.userRole.some(obj => obj.name === "admin");
  }
};
</script>

<style scoped>
/* ── Charges create modal ──────────────────────────────────── */
.create-service {
  display: flex;
  flex-direction: column;
}
</style>
